import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// FeedbackTask query

export const query = graphql(`
    query AppProvideFeedbackQuery($id:ID!) {
        feedbackTask(id:$id) {
            id
            icon
            miles
            name
            deadline
            learningPathItem {
                id
                learningPath {
                    id
                    pathname
                }
            }
            submittedFeedbackTask {
                id
                icon
                miles
                name
                instructions
                status
                finishDatetime
                selectedSubmittedTaskVariant {
                    id
                    submittedTask {
                        id
                        name
                        objectives
                        inspiration {
                            mediaType
                            src
                        }
                        people {
                            id
                            firstName
                            lastName
                        }
                        icon
                        miles
                        timeEstimate
                        finishDatetime
                        media {
                            id
                            mediaType
                            src
                            name
                            logo
                        }
                        submittedTaskVariant {
                            id
                            variantType
                            variantTitle
                            description
                            eventStart
                            eventEnd
                            taskQuestions {
                                id
                                answerType
                                questionContent
                            }
                        }
                        thread {
                            id
                            type
                            subtype
                            contentFormat
                            content
                            scaleScore {
                                earnedScore
                                possibleScore
                            }
                            person {
                                id
                                firstName
                                lastName
                                profilePicSrc
                            }
                            taskAnswers {
                                id
                                answerType
                                questionContent
                                answerContent
                                checkboxAnswers {
                                    id
                                    content
                                    checked
                                }
                                taskLikertAnswers {
                                    id
                                    statement
                                    leftLabel
                                    rightLabel
                                    value
                                }
                                showPollResults
                                quizAnswerSet {
                                    id
                                    results
                                    answers {
                                        id
                                        answer
                                        answeredQuestion {
                                            id
                                            number
                                            levelNumber
                                            description
                                            correctAnswer
                                            explanation
                                            quizOptions {
                                                id
                                                letter
                                                content
                                            }
                                        }
                                    }
                                }
                                pollAnswerSet {
                                    id
                                    pollAnswerCount
                                    answers {
                                        id
                                        answers
                                        question {
                                            id
                                            number
                                            content
                                            chartType
                                            options {
                                                id
                                                number
                                                content
                                                answerCount
                                            }
                                        }
                                    }
                                }
                                taskAnswerFile {
                                    id
                                    logoSrc
                                    src
                                    name
                                }
                                impactTrackerAnswerSet {
                                    id
                                    impactLikertAnswers {
                                        id
                                        statement
                                        leftLabel
                                        rightLabel
                                        value
                                    }
                                }
                                selectInImageMedia {
                                    id
                                    mediaType
                                    src
                                    name
                                }
                                imageSelectionAnswers {
                                    id
                                    part
                                    clickX
                                    clickY
                                    answerType
                                    answer
                                    explanation
                                }
                                imageSelectionScore {
                                    earnedScore
                                    possibleScore
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`);

export type ISubmittedTask = NonNullable<
    ResultOf<typeof query>["feedbackTask"]["submittedFeedbackTask"]
>["selectedSubmittedTaskVariant"]["submittedTask"];

// Assing answer mutation

export const assignMutation = graphql(`
    mutation AppProvideFeedbackAssignMutation($id:ID!) {
        feedbackTaskAssign(id:$id) {
            error
            feedbackTask {
                id
                submittedFeedbackTask {
                    id
                }
            }
        }
    }
`);

// Provide feedback mutation

export const feedbackMutation = graphql(`
    mutation AppProvideFeedbackMutation($id:ID!, $content:String!) {
        provideFeedback(id:$id, content:$content) {
            error
            flipper
            submittedFeedbackTask {
                id
                selectedSubmittedTaskVariant {
                    id
                    submittedTask {
                        id
                        thread {
                            id
                        }
                    }
                }
            }
        }
    }
`);
